import * as React from 'react';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIDetailsBasis, { IProps as IUIDetailsBasisProps } from './UI.Details.Basis';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import { Row, Col, Table, Divider, Tooltip } from 'antd';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IUIDetailsBasisProps, IReduxStatePart {
}

/** 详情产品1 */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIDetailsUserdCar extends UIDetailsBasis<IProps, ModulesState> {
    
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    renderNItem = (leftData, rightData) => {
        return (
            <div className={`${css.itemBox} ${css.flexRow}  ${css.flexMBetween}`}>
                <div className={`${css.item} ${css.flexRow}  ${css.flexMStart}`}>
                    <div className={css.itemTitles}>
                        {
                            Array.from(leftData.keys()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                    <div className={css.itemValues}>
                        {
                            Array.from(leftData.values()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className={`${css.item} ${css.flexRow}  ${css.flexMEnd}`}>
                    <div className={css.itemTitles}>
                        {
                            Array.from(rightData.keys()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                    <div className={css.itemValues}>
                        {
                            Array.from(rightData.values()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
    render() {
        const columns = [
            {
              title: <span style={{fontWeight: 800}}>车牌照号</span>,
              dataIndex: 'licensePlate',
              key: 'licensePlate'
            },
            {
              title: <span style={{fontWeight: 800}}>登记证号</span>,
              dataIndex: 'registrationNo',
              key: 'registrationNo',
            },
            {
              title: <span style={{fontWeight: 800}}>车辆类型</span>,
              dataIndex: 'vehicleType',
              key: 'vehicleType',
            },
            {
              title: <span style={{fontWeight: 800}}>车架号/车辆识别代码</span>,
              key: 'vehicleNo',
              dataIndex: 'vehicleNo',
            },
            {
              title: <span style={{fontWeight: 800}}>厂牌型号</span>,
              key: 'factoryModel',
              dataIndex: 'factoryModel',
            },
            {
              title: <span style={{fontWeight: 800}}>车价合计</span>,
              key: 'carPrice',
              dataIndex: 'carPrice',
            },
            {
              title: <span style={{fontWeight: 800}}>转入地车辆管理所名称</span>,
              key: 'transferredVehicleOffice',
              dataIndex: 'transferredVehicleOffice',
            }
        ];
        const invoiceDetails = this.modulesState.invoiceDetails as any;
        return (
            <div className={css.newDetails}>
                {
                    this.renderNItem(new Map([
                        ['买方单位/个人', <span key={'买方单位/个人'} style={{fontWeight: 800}}>{invoiceDetails.buyerUnitOrIndividual}</span>],
                        ['买方单位代码/身份证号码', invoiceDetails.buyerUnitCodeOrIdNo],
                        ['买方单位/个人住址及电话', invoiceDetails.buyerUnitOrIndividualAddress + invoiceDetails.buyerPhone]
                    ]), new Map([
                        ['发票代码', invoiceDetails.invoiceCode],
                        ['发票号码', invoiceDetails.invoiceNumber],
                        ['开票日期', invoiceDetails.invoiceDate ? moment.unix(invoiceDetails.invoiceDate / 1000).format('YYYY-MM-DD') : ""]
                    ]))
                }
                <Table 
                    columns={columns} 
                    dataSource={[{
                        ...invoiceDetails
                    }]}
                    pagination={false}
                />
                {
                    this.renderNItem(new Map([
                        ['经营、拍卖单位', ''],
                        ['纳税人识别号', ''],
                        ['经拍单位地址及电话', ''],
                        ['开户银行及账号', '']
                    ]), new Map([
                        ['二手车市场', <span key={'二手车市场'} style={{fontWeight: 800}}>{invoiceDetails.lemonMarket}</span>],
                        ['纳税人识别号', invoiceDetails.lemonMarketTaxNo],
                        ['二手车市场地址及电话', invoiceDetails.lemonMarketAddress + invoiceDetails.lemonMarketPhone],
                        ['开户银行及账号', invoiceDetails.lemonMarketBankAndAccount]
                    ]))
                }
                <Divider/>
                {
                    this.renderNItem(new Map(),
                     new Map([
                        ['总金额(大写)', invoiceDetails.carPrice ? <span key={'二手车市场'} style={{fontWeight: 800}}>{Field.toStringChinese(invoiceDetails.carPrice)}</span> : ''],
                        ['合计金额(小写)', invoiceDetails.carPrice? <span key={'二手车市场'} style={{fontWeight: 800}}>{`¥${Field.formatMoney(invoiceDetails.carPrice, 2)}`}</span>: ''],
                    ]))
                }
                <Divider/>
                {
                    this.renderNItem(new Map([
                        ['卖方单位/个人', <span key={'二手车市场'} style={{fontWeight: 800}}>{invoiceDetails.sellerUnitOrIndividual}</span>],
                        ['卖方单位代码/身份证号码', invoiceDetails.sellerUnitCodeOrIdNo],
                        ['卖方单位/个人住址及电话', invoiceDetails.sellerUnitOrIndividualAddress + invoiceDetails.sellerPhone]
                    ]), new Map([
                        ['备注', invoiceDetails.remark]
                    ]))
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceDetails/UI.Details.userdCar.tsx